import { useState } from "react";
import { DateRange } from "react-day-picker";
import {
	searchDateRangeFormString,
	searchLabelStyle,
} from "src/components/common/common";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
// import { KioskSwitchButtonForm } from "src/components/common/form/KioskSwitchButtonForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useKSK1110_R01Store } from "./Store_KSK1110_R01";

export const SearchSection_KSK1110_R01 = () => {
	const { inoutClassList } = useCommonCodeStore();
	const { KSK1110_R01Filter, setKSK1110_R01Filter } = useKSK1110_R01Store();
	const [datePickerVisible, setDatePickerVisible] = useState(false);
	const [datePickerPosition, setDatePickerPosition] = useState({ top: 0, left: 0 });

	const incomingClassList = inoutClassList.filter((code) =>
		code.minorCd === "110" || code.minorCd === "170",
	);

	const handleInoutClassChange = (value: string) => {
		setKSK1110_R01Filter({
			inoutClass: value === "110" || value === "170" ? value : "",
		});
	};

	return (
		<SearchSectionDoubleForm>
			<SearchDateRangeForm
				label="입고기간"
				visible={datePickerVisible}
				setVisible={setDatePickerVisible}
				dateRange={KSK1110_R01Filter.dateRange}
				setDateRange={(dateRange: DateRange | undefined) =>
					setKSK1110_R01Filter({ dateRange })}
				pickerPosition={datePickerPosition}
				setPickerPosition={setDatePickerPosition}
				wrapperOption={{
					wrapperStyle: "w-[390px] min-w-[390px]",
					titleStyle: `${searchLabelStyle} w-[90px] min-w-[90px] text-left`,
					dateRangeStyle: `${searchDateRangeFormString} w-[290px] min-w-[290px]`,
				}}
			/>
			<SearchDropDownForm<SysCodeDto>
				label="입고구분"
				value={KSK1110_R01Filter.inoutClass}
				optionList={incomingClassList}
				initLabelLess={false}
				onChangeValue={handleInoutClassChange}
				wrapperOption={{
					wrapperStyle: "w-[250px] min-w-[250px]",
					titleStyle: `${searchLabelStyle} w-[90px] min-w-[90px] text-left`,
					selectStyle: "w-[150px] min-w-[150px]",
				}}
			/>
			{/* <KioskSwitchButtonForm
				title="완료 포함"
				name="includeCompleted"
				value={KSK1110_R01Filter.includeCompleted ? "Y" : "N"}
				onChange={(_, value) => setKSK1110_R01Filter({ includeCompleted: value === "Y" })}
				wrapperOption={{
					wrapperStyle: "w-[190px] min-w-[190px]",
					titleStyle: "w-[90px] min-w-[90px] text-left",
					inputStyle: "w-[80px] min-w-[80px]",
				}}
			/> */}
		</SearchSectionDoubleForm>
	);
};
